/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-clear.scss'
import template from 'lui-clear.html'

export default class LuiClear extends LuiBase {
  static get is() {
    return 'lui-clear'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  onConnected() {
    super.onConnected()
    this.addEventListener('click', this._onClick)
  }

  onDisconnected() {
    super.onDisconnected()
    this.removeEventListener('click', this._onClick)
  }

  /**
   * The event is fired after lui-clear was clicked.
   *
   * @fires lui-clear:clicked
   */
  _onClick() {
    this.dispatchEvent(new CustomEvent('lui-clear:clicked', { bubbles: true, composed: true }))
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-clear/lui-clear.js
// module id = 192
// module chunks = 0 1 35